import {ThemeVariableType} from '@toolify/client/src/modules/theme/enum/ThemeVariableType'

export const ReadableTextBackgroundColorTypes = [
  ThemeVariableType.SurfaceColor,
  ThemeVariableType.ContainerLowestColor,
  ThemeVariableType.ContainerLowColor,
  ThemeVariableType.ContainerColor,
] as const
